<template>
  <div class="uk-margin uk-width-large uk-margin-auto uk-card uk-card-default uk-card-body uk-box-shadow-large">
    <form @submit.prevent="validateBeforeSubmit">
      <section>
        <h3 class="subtitle">{{$t('login.title')}}
          <router-link to="/">{{$t('name')}}</router-link>
        </h3>
        <b-field
          :type="{'is-danger': errors.has('email')}"
          :message="[
            errors.firstByRule('email', 'required') ? $t('validate.email_required') : null
          ]">
          <b-input
            name="email"
            :placeholder="$t('login.email_placeholder')"
            type="email"
            icon="at"
            v-validate="'required'"
            v-model="model.email">
          </b-input>
        </b-field>
        <b-field 
          :type="{'is-danger': errors.has('password')}"
          :message="[
            errors.firstByRule('password', 'required') ? $t('validate.password_dismiss') : null
          ]">
          <b-input
            :placeholder="$t('login.password_placeholder')"
            type="password"
            icon="key"
            name="password"
            password-reveal
            v-model="model.password"
            v-validate="'required'">
          </b-input>
        </b-field>
        <vue-recaptcha v-if="need_capcha"
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="invisible"
          :sitekey="key_capcha">
        </vue-recaptcha>
        <b-field grouped>
          <b-field>
            <button class="button is-primary">{{$t('login.submit')}}</button>
          </b-field>
          <b-field position="is-right">
            <router-link to="/register" class="button is-primary">
              {{$t('login.another')}}
            </router-link>
          </b-field>
        </b-field>
      </section>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    errors: '',
});

// import { doLoginClient, needCaptcha, getCaptchaKey } from "@/api"
import { doLoginClient } from "@/api"
import { EventBus } from '@/utils'
// import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'LoginСlient',
  components: {
    VueRecaptcha: () => import('vue-recaptcha'),
  },
  props: {
    //
  },
  data: function () {
    return {
      model: {
        email: '',
        password: ''
      },
      // need_capcha: false,
      // key_capcha: null,
      next: "/"
    }
  },
  created: function() {
    //
  },
  beforeMount: function(){
    //
  },
  computed: {
    need_capcha () {
      return this.$store.getters.isNeedCaptcha
    },
    key_capcha () {
      return this.$store.getters.getCaptchaKey
    }
  },  
  mounted () {
    let $this = this

    // getCaptchaKey().then(response => {
    //   if (response.data) {
    //     $this.key_capcha = response.data.data
    //   }
    // })

    // needCaptcha().then(response => {
    //  if (response.data) {
    //    if (response.data.data == true){
    //      $this.need_capcha = true
    //    }
    //  }
    // })

    EventBus.$on('errorAuthentication', (msg) => {
      $this.$toast.open({
        message: `${$this.$i18n.t('notify.server_error')}: ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
      $this.next = "/login"
    })

    EventBus.$on('failedAuthentication', (msg) => {
      $this.$toast.open({
        message: `${$this.$i18n.t('notify.error_logged_in')}: ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
      $this.model.password = ''
      $this.next = "/login"
    })

    EventBus.$on('successAuthentication', () => {
      $this.next = "/"
    })
  },
  beforeDestroy () {
    EventBus.$off('errorAuthentication')
    EventBus.$off('failedAuthentication')
    EventBus.$off('successAuthentication')
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this

      if ($this.need_capcha){
        
        $this.$validator.validateAll().then((result) => {
          if (result) {
            $this.$refs.recaptcha.execute();
            return;
          }
          $this.$toast.open({
            message: $this.$i18n.t('notify.form_error'),
            type: 'is-danger',
            position: 'is-bottom'
          })
        });
        
      }
      else{
        this.$validator.validateAll().then((result) => {
          if (result) {
            $this.sendPayload($this.model)
          }
        })
      }
      
    },
    onCaptchaVerified: function (recaptchaToken) {
      let $this = this;
      $this.$refs.recaptcha.reset();

      let payload = $this.model
      payload["g-recaptcha-response"] = recaptchaToken

      $this.sendPayload(payload)
      
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    sendPayload: function (payload) {
      let $this = this;

      $this.$store.dispatch('loginClient', payload).then(() => {
        $this.$router.push($this.next)
      })
    }
  }
}
</script>

<style scoped>
</style>
<style>
</style>